<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <h1 class="section-header">Newborn Immigration Information</h1>
  <hr />
  <div>
    <section [formGroup]="getControl('data')">
      <nh-field
        [attr.aria-required]="true"
        id="neim_eligibleImmigration"
        [mandatory]="true"
        label="Does {{ babyName }} have a valid immigration status?"
        class="label-section"
      >
        <select
          nh
          name="eligibleImmigration"
          [attr.aria-label]="
            'Does ' + babyName + ' have a valid immigration status?'
          "
          [attr.disabled]="isEligible"
          [items]="tables.YESNO"
          formControlName="eligibleImmigration"
          aria-required="true"
        ></select>
      </nh-field>

      @if (isY('data.eligibleImmigration')) {
      <div [formGroup]="getControl('data.immigration')">
        @if (!updateToNonQualifiedCitizenshipSwitch){
        <nh-field
          id="neim_status"
          label="What is {{ babyName }}'s immigration status?"
          class="label-section"
        >
          <nh-popover
            class="ps-1"
            content="{{ 'IMMIGRATION_STATIC_TEXT20' | translate }}"
          ></nh-popover>
          @if (!isPresumptive) {
          <select
            nh
            name="status"
            [attr.aria-label]="'What is ' + babyName + 's immigration status?'"
            [items]="tables.ALIENSTATUS"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="status"
            (change)="otherStatus()"
            aria-required="true"
          ></select>
          } @if (isPresumptive) {
          <select
            nh
            name="status"
            [attr.aria-label]="'What is ' + babyName + 's immigration status?'"
            [items]="tables.ALIENSTATUS_PP"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="status"
            (change)="otherStatus()"
            aria-required="true"
          ></select>
          }
        </nh-field>
      }
      @if (updateToNonQualifiedCitizenshipSwitch){
        <nh-field
          [attr.aria-required]="updateToNonQualifiedCitizenshipSwitch"
          [mandatory]="updateToNonQualifiedCitizenshipSwitch"
          [isRow]="true"
          id="nb_current_immigration_status"
          label="What is {{ babyName }}'s current immigration status?"
          class="label-section"
        >
          <select
            nh
            name="currentImmigrationStatus"
            [attr.aria-label]="'What is ' + babyName + 's current immigration status?'"
            [items]="tables.CURRENTIMMISTATUS"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="currentImmigrationStatus"
            (change)="currentImmigrationStatusChange()"
            [required]="updateToNonQualifiedCitizenshipSwitch"
          ></select>
        </nh-field>
        @if (getValue('data.immigration.currentImmigrationStatus')?.code === 'LP'){
        <nh-field
          [attr.aria-required]="true"
          [mandatory]="true"
          [isRow]="true"
          id="neim_status"
          label="What immigration status did {{ babyName }} come into the U.S. with? You may know this as Class of Admission (COA)."
          class="label-section"
        >
          <nh-popover
            class="ps-1"
            content="{{ 'IMMIGRATION_STATIC_TEXT23' | translate }}"
          ></nh-popover>
          @if (!isPresumptive) {
          <select
            nh
            name="status"
            [attr.aria-label]="'What immigration status did ' + babyName + ' come into the U.S. with? You may know this as Class of Admission (COA).'"
            [items]="tables.ALIENSTATUS"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="status"
            (change)="otherStatus()"
            [required]="getValue('data.immigration.currentImmigrationStatus')?.code === 'LP'"
          ></select>
          } @if (isPresumptive) {
          <select
            nh
            name="status"
            [attr.aria-label]="'What immigration status did ' + babyName + ' come into the U.S. with? You may know this as Class of Admission (COA).'"
            [items]="tables.ALIENSTATUS_PP"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="status"
            (change)="otherStatus()"
            [required]="getValue('data.immigration.currentImmigrationStatus')?.code === 'LP'"
          ></select>
          }
        </nh-field>
        }
      }
        @if (isEnabled('data.immigration.statusGainDate')) {
        <div>
          <nh-field
            id="neim_statusGainDate"
            [mandatory]="false"
            [attr.aria-required]="false"
            label="What date did {{ babyName }} gain this status?"
            class="label-section"
          >
            <nh-datepicker [readOnly]="isImmigrationDisabled">
              <input
                type="text"
                name="statusGainDate"
                class="form-control"
                [attr.aria-label]="
                  'What date did ' + babyName + ' gain this status?'
                "
                [attr.disabled]="isImmigrationDisabled"
                (change)="isInvalidDate($event)"
                formControlName="statusGainDate"
                bsDatepicker
                nh
                [maxDate]="today"
                [minDate]="minDate"
              />
            </nh-datepicker>
          </nh-field>
        </div>
        }
      </div>
      }

      <div [formGroup]="getControl('data.immigration.document')">
        @if (isEnabled('data.immigration.document.documentDescription')) {
        <nh-field
          id="neim_documentDescription"
          [mandatory]="documentDescription"
          [attr.aria-required]="documentDescription"
          label="Document Description"
          class="label-section"
        >
          <input
            aria-label="documentDescription"
            type="text"
            name="documentDescription"
            class="form-control"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="documentDescription"
            maxlength="35"
          />
        </nh-field>
        } @if (isY('data.eligibleImmigration') && 
        ((!updateToNonQualifiedCitizenshipSwitch && getValue('data.immigration.status')?.code && getValue('data.immigration.status').code !== 'NA' && getValue('data.immigration.status').code !== 'UA') ||
         (updateToNonQualifiedCitizenshipSwitch && getValue('data.immigration.currentImmigrationStatus')?.code && 
          (getValue('data.immigration.currentImmigrationStatus').code !== 'LP' || 
           (getValue('data.immigration.currentImmigrationStatus').code === 'LP' && getValue('data.immigration.status')?.code && getValue('data.immigration.status').code !== 'NA' && getValue('data.immigration.status').code !== 'UA'))))) {
        <div>
          <p class="hint semibold">
            {{ "IMMIGRATION_STATIC_TEXT19" | translate }}
          </p>
        </div>
        } @if (isEnabled('data.immigration.document.docType')) {
        <nh-field
          id="neim_docType"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="What is {{ babyName }}'s immigration document type?"
          class="label-section"
        >
          <select
            nh
            name="proxyDocType"
            [attr.aria-label]="
              'What is ' + babyName + 's immigration document type?'
            "
            [items]="tables.ALIENDOCTYPE"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="docType"
          ></select>
        </nh-field>
        } @if (isEnabled('data.immigration.document.registrationNumber')) {
        <nh-field
          id="neim_registrationNumber"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="Alien Number"
          class="label-section"
        >
          <div class="d-flex align-items-center">
            <span class="pl-2">A</span><span class="pl-2 pe-2"> - </span
            ><input
              type="text"
              name="registrationNumber"
              aria-label="Alien Number"
              class="form-control"
              [attr.disabled]="isImmigrationDisabled"
              formControlName="registrationNumber"
              mask="999999999"
            />
          </div>
        </nh-field>
        } @if (isEnabled('data.immigration.document.i94')) {
        <nh-field
          id="neim_i94"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="I-94 Number"
          class="label-section"
        >
          <input
            type="text"
            aria-label="I-94 Number"
            name="i94"
            class="form-control"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="i94"
            [required]="i94"
          />
        </nh-field>
        } @if
        (isEnabled('data.immigration.document.naturalizationCertificateNumber'))
        {
        <nh-field
          id="neim_naturalizationCertificateNumber"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="Naturalization Certificate Number"
          class="label-section"
        >
          <input
            type="text"
            aria-label="naturalizationCertificateNumber"
            name="naturalizationCertificateNumber"
            class="form-control"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="naturalizationCertificateNumber"
            maxlength="12"
          />
        </nh-field>
        } @if
        (isEnabled('data.immigration.document.certificateOfCitizenshipNumber'))
        {
        <nh-field
          id="neim_certificateOfCitizenshipNumber"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="Certificate of Citizenship"
          class="label-section"
        >
          <input
            type="text"
            aria-label="Certificate of Citizenship"
            name="certificateOfCitizenshipNumber"
            class="form-control"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="certificateOfCitizenshipNumber"
            maxlength="12"
          />
        </nh-field>
        } @if (isEnabled('data.immigration.document.sevisID')) {
        <nh-field
          id="neim_sevisID"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="SEVIS ID"
          class="label-section"
        >
          <div class="d-flex align-items-center">
            <span class="pl-1">N</span><span class="pl-2 pe-2"> - </span>
            <input
              type="text"
              aria-label="sevisID"
              class="form-control"
              formControlName="sevisID"
              name="sevisID"
              maxlength="10"
            />
          </div>
        </nh-field>
        } @if (isEnabled('data.immigration.document.cardNumber')) {
        <nh-field
          id="neim_cardNumber"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="Receipt/Card Number"
          class="label-section"
        >
          <input
            type="text"
            aria-label="Receipt/Card Number"
            name="cardNumber"
            class="form-control"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="cardNumber"
            mask="SSS0000000000"
          />
        </nh-field>
        } @if (isEnabled('data.immigration.document.visa')) {
        <nh-field
          id="neim_visa"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="Visa Number"
          class="label-section"
        >
          <input
            type="text"
            aria-label="Visa Number"
            name="visa"
            class="form-control"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="visa"
            minlength="8"
            mask="AAAAAAAA"
          />
        </nh-field>
        } @if (isEnabled('data.immigration.document.passport')) {
        <nh-field
          id="neim_passport"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="Passport Number"
          class="label-section"
        >
          <input
            type="text"
            aria-label="Passport Number"
            name="passport"
            class="form-control"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="passport"
          />
        </nh-field>
        } @if (isEnabled('data.immigration.document.countryIssuance')) {
        <nh-field
          id="neim_countryIssuance"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="Country of Issuance"
          class="label-section"
        >
          <select
            nh
            aria-label="Country of Issuance"
            name="countryIssuance"
            [items]="tables.COUNTRY"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="countryIssuance"
            [required]="countryIssuance"
          ></select>
        </nh-field>
        } @if (isEnabled('data.immigration.document.expDate')) {
        <nh-field
          id="neim_expDate"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="Document/Passport Expiration Date"
          class="label-section"
        >
          <nh-datepicker [readOnly]="isImmigrationDisabled">
            <input
              type="text"
              aria-label="Document/Passport Expiration Date"
              name="expDate"
              class="form-control"
              [attr.disabled]="isImmigrationDisabled"
              (change)="isInvalidDate($event)"
              formControlName="expDate"
              bsDatepicker
              nh
              [required]="expDate"
              [minDate]="today"
            />
          </nh-datepicker>
        </nh-field>
        }
      </div>
    </section>
  </div>
</nh-form>
